/**
 * Util to determine tooltip position (left, top, right) based on segmentation item position
 * This util was specifically designed for insight pages (PI,RI) which has a set of blocks in a grid (most of the times 3 in a row)
 * The idea is to have the tooltips positioned in such a way that all but the first and last elements have position 'top'
 * The first and last respectively get left and right positions so that a tooltip never clips over the viewport
 *
 * This util also assumes that items are not flexed space-between or stretched in any way that violates the amount of items in a row
 * @param  {Number} indexOfElement      The 0-based index of the item in its array/#each loop
 * @param  {Number} amountOfItemsPerRow Constant number that sets and defines the amount of items per row
 * @return {String}                     left|top|right based on the position determined in the list
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function tooltipSideCalculation(
  indexOfElement: number,
  amountOfItemsPerRow: number,
) {
  const indexInRow = indexOfElement % amountOfItemsPerRow;

  // Is the item in the middle? Then place the tooltip on top
  if (indexInRow > 0 && indexInRow < amountOfItemsPerRow - 1) {
    return 'top';
  }

  // When it's at the start of a row, place the tooltip right
  if (indexInRow === 0) {
    return 'right';
  }

  // If the element is the last one in the list, we place it on the left side
  return 'left';
}
